"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MediaLibrary_1 = __importDefault(require("./MediaLibrary"));
var material_1 = require("@mui/material");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var editorOrigin = process.env.QPLAY_EDITOR_HOST ? process.env.QPLAY_EDITOR_HOST : "";
var EditorMediaLibrary = function (_a) {
    var editorIframeRef = _a.editorIframeRef;
    var _b = (0, q_play_components_1.useModal)(), isShown = _b.isShown, toggle = _b.toggle;
    var _c = (0, react_1.useState)(""), mimeGroup = _c[0], setMimeGroup = _c[1];
    var sendMediaLibraryMessageToEditor = function (file) {
        var data = {
            state: { open: isShown },
            type: "media-library",
            file: file
        };
        if (editorIframeRef.current && (file === null || file === void 0 ? void 0 : file.mime_type.includes(mimeGroup))) {
            editorIframeRef.current.contentWindow.postMessage(data, editorOrigin);
            toggle();
        }
    };
    (0, react_1.useEffect)(function () {
        var handleMessage = function (event) {
            if (event.origin !== editorOrigin || event.data.type !== "media-library") {
                // Ignore messages not from editor and not related to media library
                return;
            }
            if (event.data.command === "toggle") {
                toggle();
            }
            setMimeGroup(event.data.mimeGroup);
        };
        window.addEventListener("message", handleMessage);
        return function () {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    var dialogStyles = {
        "& .MuiDialog-paper": {
            overflow: "visible",
            borderRadius: "14px",
            maxWidth: "80%",
            maxHeight: "90%"
        }
    };
    return (react_1.default.createElement(material_1.Dialog, { open: isShown, onClose: toggle, maxWidth: "lg", fullWidth: true, sx: dialogStyles, style: { zIndex: 1000 }, "data-cy": "media-library-popup" },
        react_1.default.createElement(material_1.IconButton, { "aria-label": "close", onClick: toggle, sx: {
                background: "var(--close-btn-color)",
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                fontSize: "24px",
                cursor: "pointer",
                position: "absolute",
                right: -21,
                top: -21,
                "&:hover": {
                    background: "var(--close-btn-color)",
                },
            } },
            react_1.default.createElement("div", { "data-cy": "modalCloseBtn" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faXmark, style: { color: "var(--info-color)" } }))),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(MediaLibrary_1.default, { permissions: {
                    read: ["global-media-read",],
                    write: ["global-media-write"],
                    manage: ["global-media-manager"],
                }, mode: "editor", sendEditorFileMessage: sendMediaLibraryMessageToEditor, mimeGroup: mimeGroup }))));
};
exports.default = EditorMediaLibrary;
